import * as z from "zod";

// Request password reset schema
export const requestPasswordResetSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
});

export const requestPasswordResetResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});

// Reset password schema
export const resetPasswordSchema = z.object({
  token: z.string().min(1, "Token is required"),
  newPassword: z.string().min(8, "Password must be at least 8 characters long"),
});

export const resetPasswordResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});

export type ResetPasswordRequest = z.infer<typeof resetPasswordSchema>;
export type RequestPasswordResetRequest = z.infer<
  typeof requestPasswordResetSchema
>;

export type RequestResetPasswordResponse = z.infer<
  typeof requestPasswordResetResponseSchema
>;
export type ResetPasswordResponse = z.infer<typeof resetPasswordResponseSchema>;
